module.exports = __webpack_public_path__ + "media/images/stores6-55786f8fff295e117ca596cc2b33ab5e.jpg";